<template>
  <div class="chat">
    <div id="wrap"></div>
  </div>
</template>

<script>
import { loadJs } from '@/utils/domUtil.js'
import Vue from 'vue'
export default {
  data() {
    return {
      chatRoom: null,
      playerJsSrc: 'https://player.polyv.net/jssdk/polyv-chatroom.min.js'
    }
  },
  props: {
    pushType: {
      type: String,
      default: '1'
    },
    isShowEmoji: {
      type: Boolean,
      default() {
        return this.pushType !== '2'
      }
    },
    activityInfo: {
      type: [String, Object],
      default: ''
    }
  },
  created() {
    if (!window.PolyvChatRoom) {
      loadJs(this.playerJsSrc, this.loadChat)
    } else {
      // this.loadChat()
    }
  },
  async mounted() {},
  watch: {
    activityInfo: {
      handler: function(val) {
        if (val) {
          this.loadChat()
        }
      }
    }
  },
  computed: {},
  methods: {
    loadChat() {
      this.$nextTick(async () => {
        console.log('activityInfo', this.activityInfo)
        const PolyvChatRoom = window.PolyvChatRoom
        const userInfo = Vue.ls.get('USER_INFO')
        this.ChatRoom = new PolyvChatRoom({
          roomId: this.activityInfo.channelId,
          userId: userInfo.id,
          accountId: userInfo.id,
          nick: userInfo.nickName,
          pic: userInfo.headImgUrl,
          token: this.activityInfo.polyvChatRoomToken.token,
          enableAsk: false,
          showUserList: false,
          mediaChannelKey: this.activityInfo.polyvChatRoomToken.mediaChannelKey,
          version: '2.0',
          container: '#wrap',
          width: 300,
          height: 400,
          userType: '',
          // enableAsk: false, // 是否开启提问
          enableWelcome: false, // 是否开启欢迎语
          enableOnlyTeacher: false, // 是否开启只看讲师功能
          roomMessage: function(data) {
            // TODO
            // data为聊天室socket消息，当有聊天室消息时会触发此方法
            console.log('sssssssssssssssssssss', data)
          }
        })
      })
    }
  },
  components: {}
}
</script>
<style scoped>
@import './chat.css';
</style>
<style>
/* .chat .polyv-chat-room {
  background-color: #191919;
} */
</style>
